import { ChainId } from '@pancakesdk/mtt'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
	[ChainId.MAINNET]: '0x22B0C9d9C97FD54576D4Bc93210e05c3C8549230', // TODO
	[ChainId.TESTNET]: '0x301907b5835a2d723Fe3e9E8C5Bc5375d5c1236A',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
